module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-2400.131acdbe.svg";